var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11766_28556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H0V50H52V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11766_28556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.851562 0.806641V45.9513C0.851562 46.6354 1.09527 47.2916 1.52906 47.7753C1.96286 48.2591 2.55122 48.5309 3.16471 48.5309H43.6447M0.851562 40.1469H4.32127M0.851562 32.4079H4.32127M0.851562 24.6688H4.32127M0.851562 16.9297H4.32127M0.851562 9.19057H4.32127",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4834 19.4294C41.1246 19.4294 42.4552 18.1266 42.4552 16.5194C42.4552 14.9123 41.1246 13.6094 39.4834 13.6094C37.8422 13.6094 36.5117 14.9123 36.5117 16.5194C36.5117 18.1266 37.8422 19.4294 39.4834 19.4294Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3506 34.5622C33.9919 34.5622 35.3224 33.2593 35.3224 31.6522C35.3224 30.0449 33.9919 28.7422 32.3506 28.7422C30.7094 28.7422 29.3789 30.0449 29.3789 31.6522C29.3789 33.2593 30.7094 34.5622 32.3506 34.5622Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2764 26.4137C20.9176 26.4137 22.2482 25.1109 22.2482 23.5037C22.2482 21.8966 20.9176 20.5938 19.2764 20.5938C17.6352 20.5938 16.3047 21.8966 16.3047 23.5037C16.3047 25.1109 17.6352 26.4137 19.2764 26.4137Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9561 43.8747C12.5974 43.8747 13.9279 42.5718 13.9279 40.9647C13.9279 39.3574 12.5974 38.0547 10.9561 38.0547C9.31489 38.0547 7.98438 39.3574 7.98438 40.9647C7.98438 42.5718 9.31489 43.8747 10.9561 43.8747Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6445 37.2407L17.1735 27.2302M28.9178 29.6048L22.3919 25.6472M37.5953 20.2578L34.1719 28.045",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9995 42.9783C51.9688 43.0287 51.861 44.0435 51.6765 46.0229C51.4919 48.0024 51.3842 49.0256 51.3535 49.0927V49.1933H44.7317C41.3478 49.1933 39.379 49.1933 38.8252 49.1933C38.2715 49.1933 37.9792 49.1514 37.9485 49.0676V49.0424C37.9023 48.9417 37.9023 48.8494 37.9485 48.7656L38.3176 48.2876C38.5638 47.9856 38.9329 47.5326 39.4251 46.9288C39.9173 46.3249 40.3865 45.7462 40.8325 45.1926L43.6704 41.67L37.9254 32.989L37.9023 32.6368C37.9023 32.3181 37.9407 32.1252 38.0177 32.0581C38.0639 32.0245 40.3018 32.0078 44.7317 32.0078H51.3535V32.1084C51.3842 32.1923 51.4919 33.1568 51.6765 35.002C51.861 36.8472 51.9688 37.8285 51.9995 37.9459V38.0465H51.0766V37.9459C50.9536 36.973 50.7843 36.1678 50.569 35.5304C50.3537 34.8929 50.0076 34.3729 49.5308 33.9703C49.0693 33.6181 48.4464 33.4001 47.662 33.3162C46.8775 33.2323 45.7623 33.182 44.3164 33.1652H43.4166H40.994L43.3935 36.7633C43.7165 37.2498 44.1165 37.8537 44.5933 38.5751C45.4392 39.8499 45.8622 40.5376 45.8622 40.6382C45.8622 40.6718 45.8545 40.6969 45.8392 40.7138L40.1864 47.7591C44.078 47.7591 46.1853 47.7507 46.5083 47.734C47.2467 47.7004 47.8618 47.6165 48.3541 47.4823C48.8463 47.3481 49.1771 47.2223 49.3462 47.1049C49.5154 46.9875 49.7 46.8197 49.9 46.6016C50.2075 46.2326 50.4614 45.7378 50.6613 45.1171C50.8613 44.4965 50.9843 43.968 51.0304 43.5319L51.0766 42.8777H51.9995V42.9783Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.6372ef85b24fbcee56b75af2d8cfa257.svg";
export { ForwardRef as ReactComponent };